module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fb-Ge-Hc-Ia.89fdef1a.png";